import { useEffect, useMemo, useState } from 'react';
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef } from 'react';
import { useApp } from '../../contexts';

export default function Ar3DViewer({ showAction = true, showZoom = true, ...props }) {
    const { T: t } = useApp();
    const viewRef = useRef()
    const [actions, setActions] = useState([]);
    const [animate, setAnimate] = useState("");
    const publicId = useMemo(() => props.publicId, [props.publicId]);
    const { isCamera } = props;

    const cloudinaryInfo = useMemo(() => props.cloudinaryInfo, [props.cloudinaryInfo]);
    const changeAnimate = (animation) => {
        setAnimate(animation);
    }
    function loadGLTFModel(scene, glbPath, options) {
        const { receiveShadow, castShadow } = options;
        return new Promise((resolve, reject) => {
            try {
                const loader = new GLTFLoader();
                loader.load(
                    glbPath,
                    (gltf) => {
                        const lst = [...gltf.animations];
                        setActions(lst);
                    },
                    undefined,
                    function (error) {
                        console.log(error);
                        // reject(error);
                    }
                )
            } catch (e) {
                console.log(e)
            }

        });
    }

    const decorate = (input) => {
        return input.split('_').join(' ')
    }

    useEffect(() => {
        const rootShadown = viewRef?.current?.shadowRoot
        const zoomEl = rootShadown?.querySelector('#controls')
        if (!showZoom) {
            zoomEl?.remove()
        }
        const scene = new THREE.Scene();
        loadGLTFModel(
            scene,
            cloudinaryInfo?.url,
            {
                receiveShadow: false,
                castShadow: false
            }
        ).then(() => {
            console.log(scene);
        });
    }, [publicId]);
    const bgurl = `${process.env.BASE_URL}/assets/images/bg-3d.png`
    return (
      <>
        {(cloudinaryInfo?.format == "glb" ||
          cloudinaryInfo?.format == "gltz") && (
          <>
            <div
              className={`ar-3d-area ${
                actions && actions.length > 0 && showAction ? "" : " no-action"
              }`}
            >
              <model-viewer
                ref={viewRef}
                style={{
                  height: "100%",
                  width: "100%",
                  // background: `url(${bgurl}) no-repeat center/100% 100%`,
                  borderRadius: "20px",
                }}
                alt=""
                src={cloudinaryInfo?.url}
                camera-controls
                touch-action="pan-y"
                camera-orbit={isCamera ? "-15.142746deg 100.967deg" : undefined}
                autoplay
                animation-name={animate}
              ></model-viewer>
            </div>
            {actions && actions.length > 0 && showAction && false && (
              <>
                <Swiper
                  className="list-3d-actions"
                  slidesPerView={"auto"}
                  spaceBetween={10}
                  grabCursor={false}
                  pagination={false}
                  watchOverflow={true}
                  navigation={true}
                >
                  <SwiperSlide>
                    <div
                      style={{
                        padding: animate == "" ? 1 : 0,
                        borderRadius: "6px",
                        background: "#F12E11",
                      }}
                    >
                      <div className="bg-white" style={{ borderRadius: "5px" }}>
                        <div
                          onClick={() => changeAnimate("")}
                          className={`list-actions-item ${
                            animate == "" ? "active !border-none" : ""
                          }`}
                        >
                          <span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="17"
                              height="17"
                              viewBox="0 0 17 17"
                              fill="none"
                            >
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M8.5 0C13.1913 0 17 3.80872 17 8.5C17 13.1913 13.1913 17 8.5 17C3.80872 17 0 13.1913 0 8.5C0 3.80872 3.80872 0 8.5 0ZM12.84 3.06734C11.65 2.115 10.1409 1.54545 8.5 1.54545C4.66182 1.54545 1.54545 4.66182 1.54545 8.5C1.54545 10.1409 2.115 11.65 3.06734 12.84L12.84 3.06734ZM4.16003 13.9327C5.35003 14.885 6.85907 15.4545 8.5 15.4545C12.3382 15.4545 15.4545 12.3382 15.4545 8.5C15.4545 6.85907 14.885 5.35003 13.9327 4.16003L4.16003 13.9327Z"
                                fill="#E8E8E8"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                  {actions.map((action, i) => {
                    return (
                      <SwiperSlide key={i}>
                        <div
                          style={{
                            padding: action.name == animate ? 1 : 0,
                            borderRadius: "6px",
                            background: "#F12E11",
                          }}
                        >
                          <div
                            className="bg-white"
                            style={{ borderRadius: "5px" }}
                          >
                            <div
                              onClick={() => changeAnimate(action.name)}
                              className={`list-actions-item ${
                                action.name == animate
                                  ? "active !border-none"
                                  : ""
                              }`}
                            >
                              <span>{decorate(action.name)}</span>
                            </div>
                          </div>
                        </div>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </>
            )}
          </>
        )}
        {typeof window !== "undefined" &&
          cloudinaryInfo &&
          cloudinaryInfo?.format != "glb" &&
          cloudinaryInfo?.format != "gltz" && (
            <>
              <div className={`ar-3d-area flex items-center justify-center`}>
                {t("Your item will be previewed here")}
              </div>
            </>
          )}
      </>
    );
}